import { render } from "./LicenseMarketplaceDialog.vue?vue&type=template&id=635fb78c&scoped=true"
import script from "./LicenseMarketplaceDialog.vue?vue&type=script&lang=js"
export * from "./LicenseMarketplaceDialog.vue?vue&type=script&lang=js"

import "./LicenseMarketplaceDialog.vue?vue&type=style&index=0&id=635fb78c&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635fb78c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
